import React, {useState} from 'react';
import {Button, FormControl} from "react-bootstrap";
import {useStores} from "../../stores/Context";
import axios from "axios";
import {v4 as uuidv4} from "uuid";
import styles from "./CreateForm.module.scss";
import styles_meteo from "./CreateMeteo.module.scss";
import {BackCreateWidgetHome, TitreConfigurerPhidget, WidgetTitre} from "./FormConfiguration";
import BtnPrimary from "../../boiteAOutils/BtnPrimary";
import BtnSecondary from "../../boiteAOutils/BtnSecondary";

const CreateMeteo = () => {
    const [searchCity, setSearchCity] = useState("");
    const [data, setData] = useState([]);
    const [widgetName, setWidgetName] = useState('');
    const [alertWidgetName, setAlertWidgetName] = useState(false);
    const [alertSearchCity, setAlertSearchCity] = useState(false);

    const {createWidgetStore, widgetStore, uiStore} = useStores();

    const handleChange = (e) => {
        let value = e.target.value;
        setSearchCity(value);
    }

    const findCity = () => {
        if (searchCity.length >= 2 && widgetName.length >= 3) {
            setAlertWidgetName(false);
            setAlertSearchCity(false);
            /* **********************************************
             * Requête API pour récupérer les villes
             * PEP : Si on dois changer d'API, pour récupérer les villes hors de France.
             * Il faut changer en suivant celle-ci :
             * https://openweathermap.org/api/geocoding-api
             * **********************************************/
            // let url = "https://api-adresse.data.gouv.fr/search/?q=" + searchCity + "&type=municipality"
            let url = process.env.REACT_APP_API_URL + "/api/getMunicipalityAPI?city=" + searchCity

            axios.get(url)
                .then((res) => {
                    setData(res.data.features);
                });
        } else {
            // champ vide
            if (widgetName.length < 3) {
                setAlertWidgetName(true);
            } else {
                setAlertWidgetName(false);
            }
            if (searchCity.length < 2) {
                setAlertSearchCity(true);
            } else {
                setAlertSearchCity(false);
            }
            setData([]);
        }
    }

    const handleCancelAddMeteo = () => {
        uiStore.openCreationMode();
        createWidgetStore.resetCreateWidget();
    }

    const handleCancel = () => {
        setData([]);
    }

    const handleChoiceCity = (id) => {
        //data[id].geometry.coordinates[0] : lon
        //data[id].geometry.coordinates[1] : lat
        let long = data[id].geometry.coordinates[0];
        let lat = data[id].geometry.coordinates[1];

        widgetStore.addWidgetAvailable({
            idWidget: uuidv4()
            , typeWidget: 'WidgetMeteo'
            , nomWidget: widgetName
            , w: 2
            , h: 2
            , config: {
                met_latitude: lat.toString(),
                met_longitude: long.toString()
            }
        });
        // uiStore.closeCreationMode();
        uiStore.backNivOAfterAddPhidget();
    }

    return (
        <>
            <div>
                <TitreConfigurerPhidget/>
                <WidgetTitre titre={"Météo"}/>
            </div>

            {data.length !== 0 ? (
                <div className={styles_meteo.listCityMeteo}>
                    {data.map((city, i) => {
                        return (
                            <div className={styles_meteo.cityMeteo}>
                                <h5>{city.properties.name}</h5>
                                <p>{city.properties.context}</p>
                                <BtnPrimary onClick={() => handleChoiceCity(i)}>Ajouter à mes phidgets</BtnPrimary>
                            </div>
                        )
                    })}
                    <div className={styles.WidgetButtonContent}>
                        <BtnSecondary onClick={handleCancel}>Retour</BtnSecondary>
                    </div>
                </div>
            ) : (
                <div className={styles.listeChampsFormulaire}>
                    <div className={styles.form_add_widget}>
                        <label>Nom du phidget </label>
                        <FormControl className={styles.input_add_widget} onChange={(e) => {
                            setWidgetName(e.target.value)
                        }} value={widgetName}/>
                        {alertWidgetName && (
                            <p className={"text-danger"}>Minimum 3 caractères</p>
                        )}
                    </div>

                    <div className={styles.form_add_widget}>
                        <label>Nom de la ville </label>
                        <FormControl className={styles.input_add_widget} value={searchCity}
                                     onChange={handleChange}/>
                        {alertSearchCity && (
                            <p className={"text-danger"}>Minimum 2 caractères</p>
                        )}
                    </div>

                    <div className={styles.WidgetButtonContent}>
                        <BtnSecondary onClick={handleCancelAddMeteo}>Retour</BtnSecondary>
                        <BtnPrimary onClick={findCity}>Rechercher la ville</BtnPrimary>
                    </div>
                </div>
            )}
        </>
    );
};

export default CreateMeteo;